import { render, staticRenderFns } from "./SMS.vue?vue&type=template&id=40e133ed&scoped=true"
import script from "./SMS.vue?vue&type=script&lang=js"
export * from "./SMS.vue?vue&type=script&lang=js"
import style0 from "./SMS.vue?vue&type=style&index=0&id=40e133ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e133ed",
  null
  
)

export default component.exports